import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const checkboxThemeToken: any = {
  //========================= FONT =================================/
  fontSize: variableTypography["BodyLargeFontSize"],
  lineHeight: variableTypography["BodyLargeLineHeight"],
  fontFamily: variableTypography["BodyMediumFontFamily"],

  //========================= COLOR ================================/
  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorTextDisabled: variableColors["ColorFigmaNeutralGrayscaleGray60Disabled"],
  colorBgActiveDisabled:
    variableColors["ColorFigmaNeutralGrayscaleGray60Disabled"],
  colorCheckBgDisabled: variableColors["ColorFigmaNeutralWhiteWhite100"],
  colorHoverBgContainer: variableColors["ColorFigmaComplementaryBlue10"],
  colorBgContainerDisabled: variableColors["ColorFigmaNeutralGrayscaleGray30"],
  colorBorder: variableColors["ColorFigmaNeutralGrayscaleGray40"],
  colorBorderIndeterminate: variableColors["ColorFigmaComplementaryBlue50"],

  //========================= SIZES =================================/
  sizeIndeterminate: 10,
};
